import { DBSystemCode } from '@home/_config/config';

import type { IAISearchPageSupportConfig } from '@home/types/aiSearch';

const AI_SEARCH_PAGE_SUPPORT_CONFIG: IAISearchPageSupportConfig = {
  system: DBSystemCode.Opinions,
  mode: 'blacklist',
  routes: [
    {
      matchType: 'exact',
      pathname: '/opinion/Summary/HotEvent',
    },
    {
      matchType: 'exact',
      pathname: '/opinion/Report/VoiceReportingTextAnalysis',
    },
    {
      matchType: 'exact',
      pathname: '/opinion/CustomizedReports/WeeklyReport/Overview',
    },
    {
      matchType: 'exact',
      pathname: '/opinion/CustomizedReports/WeeklyReport/OfficialAccountsPerformance',
    },
    {
      matchType: 'exact',
      pathname: '/opinion/CustomizedReports/WeeklyReport/VersionPerformance',
    },
    {
      matchType: 'exact',
      pathname: '/opinion/AdCreatives',
    },
  ],
};

export default AI_SEARCH_PAGE_SUPPORT_CONFIG;
